const tabsValues = {
    participants: 'participants',
    chat: 'chat',
    waitingRoom: 'waitingRoom',
};
export default tabsValues;
